/**
 * Lioness Wishlist
 * Чистый JS для подключения через assets_url
 */
(function() {
  if (window.__lionessWishlistLoaded) return;
  window.__lionessWishlistLoaded = true;

  class LionessWishlist {
    constructor() {
      this.config = window.__lionessWishlistConfig || {
        routes: { account: '/account', cartUpdate: '/cart/update.js' },
        i18n: { add: 'Save to Wishlist', inList: 'In Wishlist' }
      };
      this.storageKey = 'lioness_wishlist';
      this.wishlistData = [];
      this.isLoggedIn = !!(this.config.customerId || window.__lionessCustomerId);
      this.init();
    }

    async init() {
      this.loadFromLocalStorage();

      if (this.isLoggedIn) {
        await this.syncFromMetafields();
      }

      this.setupEventListeners();
      this.updateUI();
    }

    // --- Storage ---

    loadFromLocalStorage() {
      try {
        const data = localStorage.getItem(this.storageKey);
        const parsed = data ? JSON.parse(data) : [];
        this.wishlistData = Array.isArray(parsed)
          ? parsed.filter(item => item && item.id && item.id !== 'undefined' && item.id !== 'null')
          : [];
      } catch (e) {
        this.wishlistData = [];
      }
    }

    saveToLocalStorage() {
      localStorage.setItem(this.storageKey, JSON.stringify(this.wishlistData));
    }

    async syncFromMetafields() {
      try {
        const accountUrl = this.config.routes.account;
        const res = await fetch(`${accountUrl}?view=wishlist-json`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) return;
        const data = await res.json();
        if (data && Array.isArray(data.wishlist)) {
          const merged = [...data.wishlist];
          this.wishlistData.forEach(item => {
            if (item.id && !merged.some(m => String(m.id) === String(item.id))) {
              merged.push(item);
            }
          });
          this.wishlistData = merged;
          this.saveToLocalStorage();
        }
      } catch (e) {}
    }

    async saveToServer() {
      if (!this.isLoggedIn) return;
      try {
        await fetch(this.config.routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { '__wishlist': JSON.stringify(this.wishlistData) }
          })
        });
      } catch (e) {}
    }

    // --- Core API ---

    async add(productId, variantId = null, handle = null) {
      if (!productId || productId === 'undefined' || productId === 'null') return;
      const strId = String(productId);
      if (this.has(strId)) return;

      this.wishlistData.push({
        id: strId,
        variantId: variantId ? String(variantId) : null,
        handle: handle || null,
        addedAt: new Date().toISOString()
      });

      this.saveToLocalStorage();
      await this.saveToServer();
      this.dispatch('wishlist:added', { productId: strId });
      this.updateUI();
    }

    async remove(productId) {
      if (!productId) return;
      const strId = String(productId);
      this.wishlistData = this.wishlistData.filter(item => String(item.id) !== strId);
      this.saveToLocalStorage();
      await this.saveToServer();
      this.dispatch('wishlist:removed', { productId: strId });
      this.updateUI();
    }

    async clear() {
      this.wishlistData = [];
      this.saveToLocalStorage();
      await this.saveToServer();
      this.dispatch('wishlist:cleared', {});
      this.updateUI();
    }

    has(productId) {
      if (!productId) return false;
      const strId = String(productId);
      return this.wishlistData.some(item => String(item.id) === strId);
    }

    getAll() { return [...this.wishlistData]; }
    getCount() { return this.wishlistData.length; }

    // --- UI ---

    setupEventListeners() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-wishlist-btn]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const { productId, variantId, productHandle } = btn.dataset;
        if (!productId) return;

        if (this.has(productId)) {
          btn.classList.add('wishlist-btn--removing');
          setTimeout(() => {
            btn.classList.remove('wishlist-btn--removing');
            this.remove(productId);
          }, 400);
        } else {
          this.add(productId, variantId, productHandle);
          btn.classList.add('wishlist-btn--animate');
          setTimeout(() => btn.classList.remove('wishlist-btn--animate'), 1500);
        }
      });

      document.addEventListener('shopify:section:load', () => this.updateUI());
    }

    setupCartDrawerObserver() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        let drawerTimer;
        new MutationObserver(() => {
          clearTimeout(drawerTimer);
          drawerTimer = setTimeout(() => this.updateUI(), 400);
        }).observe(cartDrawer, { childList: true, subtree: true });
      }
    }

    updateUI() {
      document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
        const pId = btn.dataset.productId;
        if (!pId) return;

        const active = this.has(pId);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
        const label = btn.querySelector('[data-wishlist-label]');
        if (label) {
          label.textContent = active ? this.config.i18n.inList : this.config.i18n.add;
        }
      });

      document.querySelectorAll('[data-wishlist-counter]').forEach(el => {
        const count = this.getCount();
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }

    dispatch(eventName, detail = {}) {
      document.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true }));
    }

    on(event, cb) { document.addEventListener(event, cb); }
    off(event, cb) { document.removeEventListener(event, cb); }
  }

  window.lionessWishlist = new LionessWishlist();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.lionessWishlist.setupCartDrawerObserver();
      window.lionessWishlist.updateUI();
    });
  } else {
    window.lionessWishlist.setupCartDrawerObserver();
    window.lionessWishlist.updateUI();
  }
})();